(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  const footerMobile = window.matchMedia('(max-width: 749px)');
  function syncFooterMenus(root = document) {
    root.querySelectorAll('.bx-footer__menu').forEach(menu => {
      menu.open = !footerMobile.matches;
      const toggle = menu.querySelector('summary');
      if (toggle) toggle.tabIndex = footerMobile.matches ? 0 : -1;
    });
  }
  syncFooterMenus();
  footerMobile.addEventListener('change', () => syncFooterMenus());
  document.addEventListener('shopify:section:load', event => syncFooterMenus(event.target));

  } catch(e) { console.error(e); }
})();
})();
